import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsers, faGamepad } from "@fortawesome/free-solid-svg-icons";
import { Journey } from "../../types/journey";
import StatusBadge from "./StatusBadge";

interface JourneyCardProps {
  journey: Journey;
  onClick: () => void;
}

/**
 * Component for displaying a journey in a card format
 * Shows basic journey information and status
 */
const JourneyCard = ({ journey, onClick }: JourneyCardProps) => {
  return (
    <div
      onClick={onClick}
      className="border-2 border-gray-100 rounded-xl p-5 bg-white cursor-pointer hover:border-brand/20 hover:shadow-brand/40 hover:shadow-md transition-shadow relative"
    >
      <div className="flex justify-between items-start mb-4">
        <h3
          className="font-semibold text-xl text-gray-800 truncate"
          title={journey.name}
        >
          {journey.name}
        </h3>

        {/* Status badge in top right */}
        <div className="absolute top-4 right-4">
          <StatusBadge status={journey.derived_status} />
        </div>
      </div>

      {journey.description && (
        <p
          className="text-gray-600 mb-4 line-clamp-2 text-sm"
          title={journey.description}
        >
          {journey.description}
        </p>
      )}

      <div className="flex flex-col space-y-2 text-sm text-gray-600">
        <div className="flex items-center">
          <FontAwesomeIcon icon={faGamepad} className="mr-2 w-4" fixedWidth />
          <span>
            {journey.step_count} {journey.step_count === 1 ? "game" : "games"}
          </span>
        </div>

        <div className="flex items-center">
          <FontAwesomeIcon icon={faUsers} className="mr-2 w-4" fixedWidth />
          <span>
            {journey.channels.length}{" "}
            {journey.channels.length === 1 ? "channel" : "channels"}
          </span>
        </div>
      </div>

      <div className="text-xs text-gray-500 mt-4">
        Created by {journey.created_by_name}
      </div>
    </div>
  );
};

export default JourneyCard;
